import * as B from '@blueprintjs/core';
import React from 'react';

import cs from './ContractHistory.module.scss';
import {Portfolio} from './utils';

/**
 * Picks the portfolio whose purchases are shown, or "All portfolios" for the per-portfolio totals.
 */
const PortfolioSelect: React.FC<{
  portfolios: Portfolio[];
  selected: Portfolio | null;
  onSelect: (portfolio: Portfolio | null) => void;
}> = ({portfolios, selected, onSelect}) => (
  <B.Popover
    minimal
    placement="bottom-start"
    content={
      <B.Menu className={cs.portfolioMenu}>
        {[null, ...portfolios].map((portfolio) => (
          <B.MenuItem
            key={portfolio?.id ?? ''}
            text={portfolio?.name ?? 'All portfolios'}
            icon={portfolio?.id === selected?.id ? 'small-tick' : 'blank'}
            onClick={() => onSelect(portfolio)}
          />
        ))}
      </B.Menu>
    }
  >
    <B.Button
      className={cs.portfolioSelect}
      aria-label={`Portfolio: ${selected?.name ?? 'All portfolios'}`}
      text={selected?.name ?? 'All portfolios'}
      rightIcon="caret-down"
      ellipsizeText
    />
  </B.Popover>
);

export default PortfolioSelect;
